/**
 * Ingredients Tabs functionality
 * Handles tab switching and popup for the ingredients tabs section
 */
document.addEventListener('DOMContentLoaded', function() {
  // Find all ingredients tabs sections (identified by the nav container)
  const navContainers = document.querySelectorAll('[data-ingredients-tabs-nav]');

  navContainers.forEach(navContainer => {
    const section = navContainer.closest('section');
    if (!section) return;

    const tabs = navContainer.querySelectorAll('.ingredients-tab');
    const contentWrappers = section.querySelectorAll('.ingredient-content-wrapper');

    // Tab switching
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const index = this.getAttribute('data-index');

        // Update active tab
        tabs.forEach(t => t.classList.remove('ingredients-tab--active'));
        this.classList.add('ingredients-tab--active');

        // Show/hide content wrappers
        contentWrappers.forEach(wrapper => {
          if (wrapper.getAttribute('data-index') === index) {
            wrapper.classList.remove('hidden');
          } else {
            wrapper.classList.add('hidden');
          }
        });
      });
    });
  });
});






function styleShopifyFormByWrapper({ wrapperId, debug = false }) {
  const log = (...args) => debug && console.log("[ShopifyFormStyle]", ...args);

  document.addEventListener("DOMContentLoaded", () => {
    const observer = new MutationObserver(() => {
      const wrapper = document.querySelector(`[data-forms-id="${wrapperId}"]`);
      if (!wrapper) return;

      const formEmbed = wrapper.querySelector("shopify-forms-embed");
      if (!formEmbed || !formEmbed.shadowRoot) return;

      if (formEmbed.shadowRoot.querySelector("style[data-custom-style]")) {
        observer.disconnect();
        return;
      }

      const emailInput = formEmbed.shadowRoot.querySelector('#email');
if (emailInput && !emailInput.placeholder) {
  emailInput.setAttribute('placeholder', 'Email');
}

      const style = document.createElement("style");
      style.setAttribute("data-custom-style", "true");

      style.textContent = `
      @font-face {
  font-family: 'Oakes Grotesk';
  src: url('https://cdn.shopify.com/s/files/1/0958/6455/3774/files/OakesGrotesk-Regular.woff2') format('woff2'),
       url('https://cdn.shopify.com/s/files/1/0958/6455/3774/files/OakesGrotesk-Regular.woff') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
  /* APPLY FONT TO EVERYTHING INSIDE FORM */
[data-form-root="true"],
[data-form-root="true"] * {
  font-family: 'Oakes Grotesk', sans-serif !important;
  font-weight: 400 !important;
}
      form._formFieldset_cit2d_82  {
      padding:  5px !important;
      }
        /* FORM WRAPPER BACKGROUND */
        [data-form-root="true"] {
          background: #f1ead5 !important;
          
        }

        /* REMOVE GRID IMAGE COLUMN */
        [data-sizing="form-wrapper"] > section {
          display: block !important;
        }

div:empty {
    display: none;
}
@media (max-width: 767px) {
    ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
        max-width: 100% !important;
        min-width: 77vw !important;
    }
}
._gridItemContent_1q1d2_257 {
    
    padding-bottom: 0 !important;
}

        /* INPUT FIELDS */
        input[type="text"],
input[type="email"]  {
          background: #f1ead5 !important;
          border: 1px solid #ec4b30 !important;
          border-radius: 50px !important;
          height: 60px !important;
          padding: 0 24px !important;
          font-size: 14px !important;
          width: 100% !important;
          box-sizing: border-box !important;
          box-shadow: none !important;
          color:  #ec4b30 !important;
        }

        /* LABELS */
        label {
          color: #ec4b30 !important;
          font-weight: 500 !important;
        }

        /* PHONE CONTAINER FIX */
/* PHONE WRAPPER AS SINGLE INPUT */
._formPhoneInputContainer_piv1u_6 {
  display: flex !important;
  align-items: center !important;
  background: #f1ead5 !important;
  border: 1px solid #ec4b30 !important;
  border-radius: 50px !important;
  height: 60px !important;
  padding: 0 18px 0 0px !important;
  box-sizing: border-box !important;
  gap: 2px !important;
}

/* REMOVE INNER INPUT BORDER */
._formPhoneInputField_piv1u_17 {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  height: 100% !important;
  flex: 1 !important;
  padding: 0 !important;
  font-size: 14px !important;
  box-shadow: none !important;
}

/* REMOVE COUNTRY BUTTON BORDER */
.phone-country-selector button {
border: none !important;
    background: transparent !important;
    height: 100% !important;
    padding: 0px !important;
    display: flex !important;
    align-items: center !important;
    max-height: 100%;
    box-shadow: none !important;
    padding-left: 28px !important;
}

/* REMOVE OUTER FIELD CONTAINER PADDING */
._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 {
  padding: 0 !important;
  margin: 0 !important;
}

/* LABEL COLOR */
._formPhoneInputContainer_piv1u_6 label {
  color: #ec4b30 !important;
}
  

        /* SUBMIT BUTTON */
        button[type="submit"] {
            background: #ec4b30 !important;
            color: #fff !important;
            border: none !important;
            border-radius: 150px !important;
            font-weight: 700 !important;
            font-size: 15px !important;
            letter-spacing: 0px !important;
            margin-top: 0 !important;
            padding: 20px 10px !important;
        }  
            /* HIDE FLOATING LABELS */
label {
  display: none !important;
}
  /* PLACEHOLDER STYLE */
input::placeholder {
  color: #ec4b30 !important;
  opacity: 1 !important;
  
} 
  /* PHONE PLACEHOLDER COLOR */
._formPhoneInputField_piv1u_17::placeholder {
  color: #ec4b30 !important;
  opacity: 1 !important;
}  
  
/* REMOVE DEFAULT FOCUS STYLES */
/* HARD RESET EMAIL FOCUS */
input[type="text"]:focus,
input[type="email"]:focus,
input[type="text"]:active,
input[type="email"]:active {
  border-color: #ec4b30 !important; /* keep same border */
  box-shadow: none !important;
  outline: 1px dashed #ec4b30 !important;
  outline-offset: 3.75px !important;
}

/* EMAIL FIELD FOCUS */
input[type="text"]:focus,
input[type="email"]:focus {
  outline-width: 1px !important;
  outline-style: dashed !important;
  outline-color: #ec4b30 !important;
  outline-offset: 3.75px !important;
}

/* PHONE FIELD FOCUS (WRAPPER LEVEL) */
._formPhoneInputContainer_piv1u_6:focus-within {
  outline-width: 1px !important;
  outline-style: dashed !important;
  outline-color: #ec4b30 !important;
  outline-offset: 3.75px !important;
}

div._formFieldContainer_1mxsl_5 {
    width: 100% !important;
    height: 100%;
}

/* PHONE INPUT TEXT COLOR */
._formPhoneInputField_piv1u_17 {
  color: #ec4b30 !important;
}

div#country-selector-dropdown,
._dropdownContainer_12thd_63._showUpwards_12thd_79 {
    max-height: 200px !important;
min-height: 200px !important;
height:  200px !important;
}
div[class*="_dropdownContainer"] {
  max-height: 200px !important;
  overflow: visible !important;
}

div[class*="_dropdownContainer"] * {
  max-height: none !important;
}

div[class*="_dropdownContainer"] ul {
  max-height: 200px !important;
  overflow-y: auto !important;
}
  ._formContainer_1q1d2_30 {
  overflow: visible !important;
}

/* REMOVE ALL CLIPPING ABOVE DROPDOWN */
._selectContainer_12thd_6,
.phone-country-selector,
._formPhoneInputContainer_piv1u_6,
._formContainer_1q1d2_30,
._inline_1q1d2_47 {
  overflow: visible !important;
}

._formError_1mxsl_21 {
font-size: 12px;
}

/* PHONE CONTAINER SHOULD STACK */
._formPhoneInputContainer_piv1u_6 {
  position: relative !important;
}._formPhoneInputContainer_piv1u_6 ._formError_1mxsl_21 {
  position: absolute !important;
  bottom: -18px !important;
  left: 0 !important;
  width: 100% !important;
  font-size: 12px !important;
  color: #ec4b30 !important;
}._formPhoneInputContainer_piv1u_6 {
  margin-bottom: 10px !important;
}
  output._formError_1mxsl_21 {
    font-size: 12px !important;
    margin-top: -8px;
}

h2._formBannerHeading_z5ku3_9,
._textBody_2aowh_10 p{
    color: #ec4b30 !important;
}
      `;

      formEmbed.shadowRoot.appendChild(style);
      log("Injected improved layout + styling.");
      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
}

styleShopifyFormByWrapper({
  wrapperId: "forms-root-892148",
  debug: true
});



/*
 * Calculates dynamic "price per serve" using Kaching Bundles data.
 *
 * - Reads live price from selected `.kaching-bundles__bar`
 * - Maps bundle quantity via `data-deal-bar-id` → `deal-block` JSON config
 * - Uses base serves from `.product-serves__price[data-serves]`
 *
 * Dependencies:
 * - Kaching must render `.kaching-bundles` in DOM
 * - `kaching-bundles-block` must include valid `deal-block` JSON
 * - `.product-serves__price` must include `data-serves`
 *
 * Handles bundle changes and subscription price updates via MutationObserver.
 */
(() => {

  const DEBUG = false;

  const ENABLE_FREE_SHIPPING_LABEL = true;

  function updateFreeShippingLabel() {
    if (!ENABLE_FREE_SHIPPING_LABEL) {
      document.querySelectorAll('.kaching-bundles__bar-subtitle').forEach(el => {
        el.innerText = el.innerText.replace(' | Free Shipping', '');
      });
      return;
    }

    const selectedSubscription = document.querySelector(
      '.kaching-bundles__subscriptions .kaching-bundles__bar--selected'
    );

    const isSubscribe = selectedSubscription?.innerText.includes('Subscribe');

    const subtitles = document.querySelectorAll('.kaching-bundles__bar-subtitle');

    subtitles.forEach(el => {
      let text = el.innerText.replace(' | Free Shipping', '');

      if (isSubscribe) {
        text += ' | Free Shipping';
      }

      el.innerText = text;
    });
  }

  const SELECTORS = {
    wrapper: '.kaching-bundles',
    block: 'kaching-bundles-block',
    selectedBar: '.kaching-bundles__bar--selected',
    price: '.kaching-bundles__bar-price',
    output: '.product-serves__price'
  };

  let lastPrice = null;
  let quantityMap = null;
  let lastWrittenText = null;
  let outputObserver = null;

  function log(...args) {
    if (DEBUG) console.log('[SERVE]', ...args, 'at', performance.now());
  }

  function buildQuantityMap() {
    const block = document.querySelector(SELECTORS.block);
    if (!block) {
      log('no kaching block found');
      return null;
    }

    const raw = block.getAttribute('deal-block');
    if (!raw) {
      log('no deal-block attribute');
      return null;
    }

    try {
      const parsed = JSON.parse(raw);
      const map = {};

      parsed.dealBars.forEach(bar => {
        map[bar.id] = bar.quantity;
      });

      log('quantity map built:', map);
      return map;

    } catch (e) {
      log('failed to parse deal-block JSON');
      return null;
    }
  }

  // Locale-aware price parser — handles "1,234.56", "1.234,56", "€43,20", "$43.20", etc.
  function parseLocalePrice(str) {
    const cleaned = String(str).replace(/[^\d.,\-]/g, '');
    if (!cleaned) return NaN;

    const lastDot = cleaned.lastIndexOf('.');
    const lastComma = cleaned.lastIndexOf(',');
    const lastSep = Math.max(lastDot, lastComma);

    if (lastSep === -1) return parseFloat(cleaned);

    const decPart = cleaned.slice(lastSep + 1);
    // If 1–2 digits trail the last separator, treat it as the decimal separator.
    if (decPart.length > 0 && decPart.length <= 2) {
      const intPart = cleaned.slice(0, lastSep).replace(/[.,]/g, '');
      return parseFloat(intPart + '.' + decPart);
    }
    // Otherwise both separators are thousands grouping (e.g. "1.000" = 1000).
    return parseFloat(cleaned.replace(/[.,]/g, ''));
  }

  // Format units value using the same template as a reference price string,
  // so currency symbol/position and decimal separator match the visitor's locale.
  function formatLikeReference(referenceStr, units) {
    const ref = String(referenceStr);
    const lastDot = ref.lastIndexOf('.');
    const lastComma = ref.lastIndexOf(',');
    const lastSep = Math.max(lastDot, lastComma);
    const decSep = lastSep === -1 ? '.' : ref[lastSep];
    const numericStr = units.toFixed(2).replace('.', decSep);
    return ref.replace(/[\d.,]+/, numericStr);
  }

  function getSelectedBarData() {
    const selected = document.querySelector(SELECTORS.selectedBar);
    if (!selected) return null;

    const barId = selected.getAttribute('data-deal-bar-id');
    const priceEl = selected.querySelector(SELECTORS.price);

    if (!priceEl) return null;

    const raw = priceEl.innerText || '';
    const price = parseLocalePrice(raw);

    if (!barId || isNaN(price)) return null;

    return { barId, price, raw };
  }

  function updatePerServe(price, quantity, referenceStr) {
    const outputs = document.querySelectorAll(SELECTORS.output);
    if (outputs.length === 0) {
      log('output not found');
      return;
    }

    const baseServes = parseFloat(outputs[0].dataset.serves);
    if (!baseServes || baseServes <= 0) {
      log('invalid base serves:', baseServes);
      return;
    }

    const totalServes = baseServes * quantity;
    const perServeUnits = price / totalServes;

    let priceStr;
    if (referenceStr) {
      // Mirror the Kaching bar's currency/locale formatting.
      priceStr = formatLikeReference(referenceStr, perServeUnits);
    } else if (typeof formatMoney === 'function') {
      priceStr = formatMoney(Math.round(perServeUnits * 100));
    } else {
      priceStr = perServeUnits.toFixed(2);
    }

    const formatted = priceStr + ' per serve';

    log(`update → price:${price} qty:${quantity} totalServes:${totalServes} → ${formatted}`);

    lastWrittenText = formatted;
    outputs.forEach((el) => { el.textContent = formatted; });

    setupOutputObserver();
  }

  // Defensive: Alpine's x-text may re-fire after our write (e.g. currentVariant
  // resolves late, or variant change). Watch the output element directly and
  // re-apply our last-computed value if anything else overwrites it.
  function setupOutputObserver() {
    if (outputObserver) return;
    const outputs = document.querySelectorAll(SELECTORS.output);
    if (outputs.length === 0) return;

    outputObserver = new MutationObserver(() => {
      if (!lastWrittenText) return;
      document.querySelectorAll(SELECTORS.output).forEach((el) => {
        if (el.textContent !== lastWrittenText) {
          log('output overwritten externally — re-applying');
          el.textContent = lastWrittenText;
        }
      });
    });

    outputs.forEach((el) => {
      outputObserver.observe(el, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  function sync() {
    const data = getSelectedBarData();
    if (!data) return;

    if (data.price === lastPrice) {
      log('same price, skip');
      return;
    }

    lastPrice = data.price;

    if (!quantityMap) {
      quantityMap = buildQuantityMap();
      if (!quantityMap) return;
    }

    const quantity = quantityMap[data.barId];

    if (!quantity) {
      log('no quantity for barId:', data.barId);
      return;
    }

    log('sync →', data, 'qty:', quantity);

    updatePerServe(data.price, quantity, data.raw);

    updateFreeShippingLabel();
  }

  function attachObserver(wrapper) {
    log('observer attached');

    const observer = new MutationObserver(() => {
      log('mutation detected');
      sync();
    });

    observer.observe(wrapper, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });

    sync();
  }

  function waitForWrapper() {
    log('waiting for wrapper');

    const existing = document.querySelector(SELECTORS.wrapper);
    if (existing) {
      attachObserver(existing);
      return;
    }

    const observer = new MutationObserver((_, obs) => {
      const wrapper = document.querySelector(SELECTORS.wrapper);
      if (wrapper) {
        log('wrapper appeared');
        obs.disconnect();
        attachObserver(wrapper);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Alpine's `x-text` on .product-serves__price runs after our IIFE's initial sync()
  // and overwrites our value. Re-sync once Alpine has finished initializing, and
  // again after any variant change (which causes Alpine to reset the text).
  function forceSync() {
    lastPrice = null;
    sync();
  }

  document.addEventListener('alpine:initialized', () => {
    log('alpine initialized — forcing sync');
    forceSync();
  });

  document.addEventListener('theme:variant:change', () => {
    // Defer so Alpine's x-text reactive update lands before we override it.
    requestAnimationFrame(forceSync);
  });

  log('init');
  waitForWrapper();

})();








// Delegated video controller for Splide: click toggle play/pause, restart with sound, 
// pause others, sync UI via .is-active while treating muted autoplay as the initial non-playing state
(function () {
  const DEBUG = false;
  const log = (...args) => DEBUG && console.log('[VIDEO]', ...args);

  document.addEventListener('click', function (e) {
    const wrapper = e.target.closest('.splide__list .vertical-embed-wrapper');
    if (!wrapper) return;

    const video = wrapper.querySelector('video');
    if (!video) return;

    const root = wrapper.closest('.splide__list');
    const wrappers = root.querySelectorAll('.vertical-embed-wrapper');

    const isPlaying = !video.paused && !video.ended && !video.muted;
    log('Click on wrapper. isPlaying =', isPlaying, 'muted =', video.muted);

    if (isPlaying) {
      video.pause();
    } else {
      video.currentTime = 0;
      video.muted = false;
      video.play();

      wrappers.forEach(w => {
        const v = w.querySelector('video');
        if (v && v !== video) {
          v.pause();
          v.muted = true;
          w.classList.remove('is-active');
        }
      });
    }
  });

  document.addEventListener('play', function (e) {
    if (e.target.tagName !== 'VIDEO') return;

    const video = e.target;
    const wrapper = video.closest('.vertical-embed-wrapper');
    if (!wrapper) return;

    if (video.muted) {
      wrapper.classList.remove('is-active');
      log('play ignored because muted');
      return;
    }

    wrapper.classList.add('is-active');
    log('play');
  }, true);

  document.addEventListener('pause', function (e) {
    if (e.target.tagName !== 'VIDEO') return;

    const wrapper = e.target.closest('.vertical-embed-wrapper');
    if (!wrapper) return;

    wrapper.classList.remove('is-active');
    log('pause');
  }, true);

  document.addEventListener('ended', function (e) {
    if (e.target.tagName !== 'VIDEO') return;

    const wrapper = e.target.closest('.vertical-embed-wrapper');
    if (!wrapper) return;

    wrapper.classList.remove('is-active');
    log('ended');
  }, true);

  document.addEventListener('volumechange', function (e) {
    if (e.target.tagName !== 'VIDEO') return;

    const video = e.target;
    const wrapper = video.closest('.vertical-embed-wrapper');
    if (!wrapper) return;

    const isPlaying = !video.paused && !video.ended && !video.muted;

    wrapper.classList.toggle('is-active', isPlaying);
    log('volumechange', 'muted =', video.muted, 'isPlaying =', isPlaying);
  }, true);
})();

/* =====================================================================
   FEATURE REVEAL CARDS  — start
   Section: sections/feature-reveal-cards.liquid
   Styles in: assets/custom.css  (same fence name)
   ===================================================================== */
(function () {
  'use strict';

  function initFeatureRevealCards(root) {
    if (!root || root.dataset.frcInit === '1') return;
    root.dataset.frcInit = '1';

    var row = root.querySelector('[data-frc-row]');
    var dotsHost = root.querySelector('[data-frc-dots]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-frc-card]'));
    if (!cards.length) return;

    // Click behaviour:
    //   Desktop (>=750px): NO-OP. Hover already reveals; click does nothing.
    //   Mobile (<750px):  toggles .is-flipped to reveal the panel.
    cards.forEach(function (card) {
      var btn = card.querySelector('[data-frc-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        if (window.matchMedia('(min-width: 750px)').matches) {
          e.preventDefault();
          return;
        }
        var flipped = card.classList.toggle('is-flipped');
        btn.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        if (flipped) {
          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    });

    // Resize watcher: when the viewport crosses into desktop, drop any
    // mobile-set .is-flipped state so cards don't stay stuck open.
    var desktopMQ = window.matchMedia('(min-width: 750px)');
    function syncFlippedToViewport(mqEvent) {
      if (mqEvent.matches) {
        cards.forEach(function (card) {
          card.classList.remove('is-flipped');
          var b = card.querySelector('[data-frc-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
    }
    if (desktopMQ.addEventListener) {
      desktopMQ.addEventListener('change', syncFlippedToViewport);
    } else if (desktopMQ.addListener) {
      // Safari < 14 fallback
      desktopMQ.addListener(syncFlippedToViewport);
    }

    // Mobile dots
    if (dotsHost && row && cards.length > 1) {
      dotsHost.innerHTML = '';
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'frc__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
        dot.addEventListener('click', function () {
          card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
        dotsHost.appendChild(dot);
      });

      var scrollTimer = null;
      row.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var rowRect = row.getBoundingClientRect();
          var rowCenter = rowRect.left + rowRect.width / 2;
          var nearestIdx = 0;
          var nearestDist = Infinity;
          cards.forEach(function (card, i) {
            var r = card.getBoundingClientRect();
            var d = Math.abs(r.left + r.width / 2 - rowCenter);
            if (d < nearestDist) { nearestDist = d; nearestIdx = i; }
          });
          var dots = dotsHost.querySelectorAll('.frc__dot');
          for (var i = 0; i < dots.length; i++) {
            dots[i].classList.toggle('is-active', i === nearestIdx);
          }
        }, 60);
      }, { passive: true });
    }

    // Desktop prev/next nav buttons. Visibility is driven by .frc--can-prev /
    // .frc--can-next on the wrapper, toggled on every scroll/resize based on
    // whether the row can scroll further in that direction.
    var prevBtn = root.querySelector('[data-frc-prev]');
    var nextBtn = root.querySelector('[data-frc-next]');
    if (row && (prevBtn || nextBtn)) {
      function getCardStep() {
        // Step = one card width + the row's gap. Use the first card (not the
        // spacer) so we get the right increment.
        var firstCard = cards[0];
        if (!firstCard) return row.clientWidth * 0.6;
        var gap = parseFloat(getComputedStyle(row).gap) || 0;
        return firstCard.offsetWidth + gap;
      }
      function updateNavState() {
        if (!desktopMQ.matches) {
          // Mobile: never show, just bail.
          root.classList.remove('frc--can-prev', 'frc--can-next');
          return;
        }
        var max = row.scrollWidth - row.clientWidth;
        root.classList.toggle('frc--can-prev', row.scrollLeft > 1);
        root.classList.toggle('frc--can-next', row.scrollLeft < max - 1);
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          row.scrollBy({ left: -getCardStep(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          row.scrollBy({ left: getCardStep(), behavior: 'smooth' });
        });
      }
      row.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      // Initial — defer one frame so layout has settled (especially in the
      // theme editor where the section may re-render).
      requestAnimationFrame(updateNavState);
    }

    // Desktop grab-drag scroll: mousedown on the row starts a drag; mousemove
    // pans scrollLeft proportionally; mouseup releases. Cursor swaps via the
    // .is-grabbing class on the row. Disabled on mobile (touch swipe handles
    // it natively via scroll-snap).
    if (row) {
      var drag = { active: false, startX: 0, startScroll: 0, moved: false };

      row.addEventListener('mousedown', function (e) {
        if (!desktopMQ.matches) return;
        if (e.button !== 0) return; // left mouse only
        drag.active = true;
        drag.moved = false;
        drag.startX = e.pageX;
        drag.startScroll = row.scrollLeft;
        row.classList.add('is-grabbing');
        // Prevent native image-drag and text selection during the gesture.
        e.preventDefault();
      });

      document.addEventListener('mousemove', function (e) {
        if (!drag.active) return;
        var dx = e.pageX - drag.startX;
        if (!drag.moved && Math.abs(dx) > 2) drag.moved = true;
        row.scrollLeft = drag.startScroll - dx;
      });

      function endDrag() {
        if (!drag.active) return;
        drag.active = false;
        row.classList.remove('is-grabbing');
      }
      document.addEventListener('mouseup', endDrag);
      document.addEventListener('mouseleave', endDrag);

      // Swallow the click that browsers fire after a drag-release, so the
      // card button doesn't see the gesture as a tap.
      row.addEventListener('click', function (e) {
        if (drag.moved) {
          e.preventDefault();
          e.stopPropagation();
          drag.moved = false;
        }
      }, true);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-feature-reveal-cards]');
    roots.forEach(initFeatureRevealCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is added/re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
/* =====================================================================
   FEATURE REVEAL CARDS  — end
   ===================================================================== */

/* =====================================================================
   AUTO-ROTATING CARDS  — start
   Section: sections/auto-rotating-cards.liquid
   Styles in: assets/custom.css  (same fence name)
   ===================================================================== */
(function () {
  'use strict';

  function initOne(root) {
    if (!root || root.dataset.arcInit === '1') return;
    if (!root.id) return;

    if (typeof window.makeSlideshow !== 'function') return;
    window.makeSlideshow(root);
    var splide = window.slideshows && window.slideshows[root.id];
    if (!splide) return;
    root.dataset.arcInit = '1';

    // Track drag state so a release-click after a drag doesn't advance the slider.
    var justDragged = false;
    splide.on('drag', function () { justDragged = false; });
    splide.on('dragged', function () { justDragged = true; });
    // After the drag-induced movement settles, allow taps again.
    splide.on('moved', function () { setTimeout(function () { justDragged = false; }, 50); });

    // Progress bar: swap the .arc-loading-active class at the START of
    // each slide change (`move` event) rather than at the end (`moved`).
    // setActiveProgress() toggles the class on the new active slide AND
    // off the old one in the same synchronous pass — so the old loader
    // disappears before the slide moves, and the new one appears as the
    // slide begins. By the time the card reaches center, the loader has
    // already been growing for the slide duration (~400ms ≈ 8%). No
    // perceptual gap between the card landing and the loader showing.
    function setActiveProgress(newIndex) {
      var target = (typeof newIndex === 'number') ? newIndex : splide.index;
      // Splide.Slides.get() returns all slides INCLUDING clones (passing
      // true excludes clones — opposite of what the name suggests).
      var slides = splide.Components.Slides.get();
      slides.forEach(function (s) {
        // Mark the one real slide whose .index === target. Clones have
        // .isClone=true so we exclude them — we want the loader on the
        // single real centered card only.
        var match = !s.isClone && s.index === target;
        s.slide.classList.toggle('arc-loading-active', match);
      });
    }
    splide.on('move', setActiveProgress);
    splide.on('mounted', function () { setActiveProgress(splide.index); });
    splide.on('updated', function () { setActiveProgress(splide.index); });
    // Run once now in case 'mounted' already fired.
    setActiveProgress(splide.index);

    // Click on a card → that card moves to center via the VISUALLY
    // shortest path. Splide's built-in shortest-path math (when you call
    // go(index)) doesn't always match what the user sees: a clone of
    // card 5 may visually sit on the left of center, but its slideIndex
    // is 4 — and the mathematical shortest from currentIndex 0 may be
    // forward, sending the carousel the wrong way. To avoid this we
    // explicitly use a relative offset based on the clicked card's
    // bounding box vs the active card's.
    //
    // Splide v4 Slides.get() returns ALL slides including clones; passing
    // `true` EXCLUDES clones (the opposite of what the name suggests).
    // For each Slide object:
    //   real  : .index = 0..N-1, .slideIndex = -1, .isClone = false
    //   clone : .index = outside 0..N-1, .slideIndex = original real
    //                                     index, .isClone = true
    root.querySelectorAll('[data-arc-tap]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (justDragged) {
          justDragged = false;
          e.preventDefault();
          return;
        }
        var slideEl = btn.closest('.splide__slide');
        if (!slideEl) return;

        var slides = splide.Components.Slides.get();
        var clicked = slides.find(function (s) { return s.slide === slideEl; });
        if (!clicked) return;

        // The "real" centered slide so we can compare positions.
        var activeReal = slides.find(function (s) {
          return !s.isClone && s.index === splide.index;
        });
        if (!activeReal) return;

        var clickedX = slideEl.getBoundingClientRect().left;
        var activeX  = activeReal.slide.getBoundingClientRect().left;
        // If the clicked element is essentially the active one (e.g. user
        // clicked the centered card itself), do nothing.
        if (Math.abs(clickedX - activeX) < 4) return;

        // The real slide index this click should land on.
        var targetIndex = clicked.isClone ? clicked.slideIndex : clicked.index;
        if (typeof targetIndex !== 'number' || targetIndex < 0 || targetIndex >= splide.length) return;

        var n = splide.length;
        var currentIndex = splide.index;
        // Steps via either direction to reach targetIndex from currentIndex.
        var forwardSteps  = (targetIndex - currentIndex + n) % n;
        var backwardSteps = (currentIndex - targetIndex + n) % n;
        // Direction is decided by visual position, NOT by step count.
        var offset = (clickedX < activeX) ? ('-' + backwardSteps) : ('+' + forwardSteps);
        splide.go(offset);

        // Release focus after a MOUSE click so Splide's pauseOnFocus
        // doesn't keep autoplay paused. Keyboard activation (event.detail
        // === 0) keeps focus so a11y users can hold the carousel paused
        // while reading the active card.
        if (e.detail > 0 && typeof btn.blur === 'function') btn.blur();
      });
    });

    // Theme editor: pause autoplay so cards don't slide away under the merchant.
    if (window.Shopify && Shopify.designMode) {
      var ap = splide.Components && splide.Components.Autoplay;
      if (ap && typeof ap.pause === 'function') ap.pause();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-auto-rotating-cards]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
/* =====================================================================
   AUTO-ROTATING CARDS  — end
   ===================================================================== */